<template>
  <div class="home">
    <div style="top:10px;position:absolute;left:10px;">
      <el-button type="primary" @click="back" plain>后退</el-button>
    </div>
    <div class="content">
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="oeeBoard()">KPI视图</el-button>
        </el-col>
        <el-col :span="24">
          <el-button size="medium" @click="trackingKpi()">一周KPI总览</el-button>
        </el-col>
        <el-col :span="24">
          <el-button size="medium" @click="trackingOutPut()">每日生产跟踪</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../../router";
export default {
  name: "home",
  data() {
    return {
      msg: "home",
      first: null,
      version:"1.0",
      dialogFormVisible: false,
      pageSize: 40,
      too: 10,
      listData: [],
      ruleForm: {
        pageSize: 40,
        too: 10
      }
    };
  },
  mounted() {

  },
  methods: {
    trackingKpi(){
      this.$router.push({
        path: "/oee/weekCategory"
      });
    },
    trackingOutPut() {
      this.$router.push({
        path: "/oee/weektracking_output"
      });
    },
    oeeBoard() {
      this.$router.push({
        path: "/oee/board"
      });
    },

    back() {
      router.back();
    },

    pageChange(value) {
      if (isNaN(value)) {
        value = parseInt(value);
        this.ruleForm.pageSize = isNaN(value) ? this.pageSize : value;
      }
    },

    tooChange(value) {
      if (isNaN(value)) {
        value = parseInt(value);
        this.ruleForm.too = isNaN(value) ? this.too : value;
      }
    },

    page() {
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.ruleForm.pageSize = setUp["pageSize"];
        this.ruleForm.too = setUp["too"];
      }
      this.dialogFormVisible = true;
    },

    setUp() {
      var pageSize = this.ruleForm.pageSize;
      var too = this.ruleForm.too;
      var setUp = { pageSize: pageSize, too: too };
      localStorage.setItem("setUp", JSON.stringify(setUp));
      this.dialogFormVisible = false;
    },

    defaultUp() {
      this.ruleForm.pageSize = this.pageSize;
      this.ruleForm.too = this.too;
    },

    init() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);

        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        const params = {
          Expanded: "",
          Selectable: ""
        };
        API.listTree(params)
          .then(res => {
            console.log(res);
            if (res.success === true) {
              this.listData = res.list;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./category.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/category/category.vue